import React from 'react';

const directSellingModel = null;
export default React.createContext(directSellingModel);
